module.exports = __webpack_public_path__ + "img/1.1f7b77c9.png";